/**
 * Placeholder markers.
 *
 * Samloryx Engineering (Pty) Ltd was registered on 8 August 2026. Almost nothing
 * about the company is established yet, so the prototype this site was ported from
 * — which was populated with invented registration numbers, directors, addresses,
 * contracts, clients and legal text — has had every one of those values replaced
 * with a marker below.
 *
 * Nothing in `src/content/` may be filled in from guesswork, from an older draft,
 * or from Samloryx Consultancy (a separate legal entity). Every value comes from a
 * source document or from Samuel directly. See CONTENT-TBC.md for the checklist.
 */

/** Short field: a number, a date, a name, a grading. */
export const TBC = 'TBC'

/** Field that needs a person to supply it rather than a lookup. */
export const TBC_INPUT = 'TBC — founder input required'

/** Build a descriptive placeholder that says what belongs in the slot. */
export function tbc(what: string): string {
  return `TBC — ${what}`
}
